<template>
  <div>
    <el-image :src="headImg" fit="cover" class="headimg"/>
    <div class="container">
      <el-card class="calculator-card">
        <template #header>
          <div class="card-header">原料报价</div>
        </template>

        <el-form label-position="left" label-width="120px">
          <el-form-item label="原料直径">
            <el-input
                v-model.number="d"
                placeholder="0.0"
                type="number"
                step="0.1"
                suffix-icon="el-icon-odometer"
                @keyup.enter="calculate"
            >
              <template #append>mm</template>
            </el-input>
          </el-form-item>

          <el-form-item label="原料长度">
            <el-input
                v-model.number="l"
                placeholder="0.0"
                type="number"
                step="0.1"
                suffix-icon="el-icon-crop"
                @keyup.enter="calculate"
            >
              <template #append>mm</template>
            </el-input>
          </el-form-item>

          <el-form-item label="原材料密度">
            <el-input
                v-model.number="density"
                placeholder="0.0"
                type="number"
                step="0.1"
                suffix-icon="el-icon-data-analysis"
                @keyup.enter="calculate"
            />
          </el-form-item>

          <el-form-item label="原材料价格">
            <el-input
                v-model.number="price"
                placeholder="0.0"
                type="number"
                step="0.1"
                suffix-icon="el-icon-money"
                @keyup.enter="calculate"
            >
              <template #append>元/公斤</template>
            </el-input>
          </el-form-item>
        </el-form>
      </el-card>

      <el-card class="result-card">
        <template #header>
          <div class="card-header">计算结果</div>
        </template>

        <div class="result-item">
          <span class="label">材料重量：</span>
          <span class="value">{{ materialWeight }} KG</span>
        </div>
        <div class="result-item">
          <span class="label">材料费用：</span>
          <span class="value">{{ materialCost }} 元</span>
        </div>
      </el-card>

      <div class="action-buttons">
        <el-button type="info" @click="reset">重置</el-button>
      </div>

      <div class="footer">宁波鼎新报价系统</div>
    </div>

  </div>
</template>

<script setup>
import {computed, ref} from 'vue'
import headImg from '@/assets/img/cal_head.jpg'

const d = ref('')
const l = ref('')
const density = ref('')
const price = ref('')

const materialWeight = computed(() => {
  if (!d.value || !l.value || !density.value) return '0.0000'
  const weight = (Math.pow(d.value / 2, 2) * Math.PI * l.value * density.value) / 1000000
  return weight.toFixed(4)
})

const materialCost = computed(() => {
  if (!price.value) return '0.0000'
  const cost = materialWeight.value * price.value
  return cost.toFixed(4)
})

const calculate = () => {
  // 触发计算只需要依赖计算属性即可
}

const reset = () => {
  d.value = ''
  l.value = ''
  density.value = ''
  price.value = ''
}
</script>

<style scoped>
.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

.headimg {
  width: 100%;
  margin-bottom: 20px;
  border-radius: 4px;
}

.calculator-card,
.result-card {
  margin-bottom: 20px;
}

.card-header {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.result-item {
  margin: 10px 0;
  font-size: 16px;
}

.label {
  color: #666;
}

.value {
  color: #409eff;
  font-weight: bold;
}

.action-buttons {
  text-align: center;
  margin: 20px 0;
}

.footer {
  text-align: center;
  color: #ff5722;
  font-weight: bold;
  margin-top: 20px;
}

.el-form-item {
  margin-bottom: 18px;
}

.el-input {
  width: 100%;
}
</style>